export class OldConsolidatedSessionConsumption {
  sessionByUser!: number;
  sessionByCompany!: number;
  sessionTotal!: number;
  startDateReference!: string;
  endDateReference!: string;

  constructor(oldConsolidatedSessionConsumption: Partial<OldConsolidatedSessionConsumption | null>) {
    this.sessionByUser = 0;
    this.sessionByCompany = 0;
    this.sessionTotal = 0;
    this.startDateReference = '';
    this.endDateReference = '';
    Object.assign(this, oldConsolidatedSessionConsumption);
  }
}
